import { defineComponent as W, useCssVars as $, computed as i } from "vue";
import { getImageBreakpoints as w } from "./td-longtail-vue-components256.js";
import { getConfig as L } from "./td-longtail-vue-components2.js";
import { addCdnHost as x } from "./td-longtail-vue-components251.js";
const U = /* @__PURE__ */ W({
  __name: "picture-element",
  props: {
    src: { default: void 0 },
    srcSm: { default: void 0 },
    srcMd: { default: void 0 },
    srcLg: { default: void 0 },
    srcXl: { default: void 0 },
    height: { default: void 0 },
    width: { default: void 0 },
    aspectRatio: { default: void 0 },
    aspectRatioSm: { default: void 0 },
    aspectRatioMd: { default: void 0 },
    aspectRatioLg: { default: void 0 },
    aspectRatioXl: { default: void 0 },
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    alt: { default: "" },
    lazy: { type: Boolean },
    format: { default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: { default: "" },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  setup(y, { expose: M }) {
    const t = y;
    $((a, e) => ({
      "45a0ffe9": e.aspectRatio,
      "6160b423": e.aspectRatioSm,
      "6160b360": e.aspectRatioMd,
      "6160b344": e.aspectRatioLg,
      "6160b4bd": e.aspectRatioXl
    }));
    const u = i(() => t.aspectRatio), f = i(() => t.srcSm && t.aspectRatioSm ? t.aspectRatioSm : u.value), p = i(() => t.srcMd && t.aspectRatioMd ? t.aspectRatioMd : f.value), m = i(() => t.srcLg && t.aspectRatioLg ? t.aspectRatioLg : p.value), X = i(() => t.srcXl && t.aspectRatioXl ? t.aspectRatioXl : m.value), r = i(() => w(t.sizes, {
      xs: t.src || void 0,
      sm: t.srcSm || void 0,
      md: t.srcMd || void 0,
      lg: t.srcLg || void 0,
      xl: t.srcXl || void 0
    })), v = (a) => {
      const e = r.value.findIndex((o) => o.name === a);
      for (let o = e; o >= 0; o -= 1)
        if (r.value[o].src) return r.value[o].src || void 0;
    }, c = i(() => {
      const { imageOptimizer: a } = L() || {};
      return r.value ? r.value.map(({ src: e, minWidth: o, name: d, defaultWidth: k, imageWidth: h }) => {
        const s = h || k || void 0;
        if (!e && (!s || !h)) return null;
        if (e && /\.svg/i.test(e))
          return {
            name: d,
            src: x(e),
            type: "image/svg"
          };
        if (!e && (e = v(d), !e))
          return null;
        const C = {
          sizes: `${d}:${s}`,
          modifiers: {
            format: t.format
          }
        }, z = t.doNotConvert || !a ? e : a(e, C).src, S = String(s).endsWith("vw");
        let l = s;
        if (!S && /^\d+$/.test(String(s)) && (l = `${s}px`), !S && !String(l).endsWith("px"))
          return null;
        const B = parseInt(String(l), 10);
        return B ? {
          name: d,
          width: B,
          minWidth: o,
          media: (o || 0) > 0 ? `(min-width: ${o}px)` : "",
          src: x(z),
          type: `image/${t.format}`
        } : null;
      }).filter(Boolean) : [];
    }), n = i(() => c.value?.[0]), b = i(() => [...c.value].filter((a) => a && (a.minWidth || 0) > 0).sort((a, e) => (e.minWidth || 0) - (a.minWidth || 0))), g = (a) => {
    }, R = L()?.useHead || g;
    return R(() => !t.preload || !n.value?.src ? {} : {
      link: [
        {
          rel: "preload",
          as: "image",
          fetchpriority: "high",
          href: n.value.src || ""
        }
      ]
    }), M({
      defaultImage: n
    }), { __sfc: !0, props: t, aspectRatio: u, aspectRatioSm: f, aspectRatioMd: p, aspectRatioLg: m, aspectRatioXl: X, imagesBreakpoints: r, getLastSource: v, sourcesByBreakpoint: c, defaultImage: n, sourcesWithBreakpointReverse: b, mockUseHead: g, useHead: R };
  }
});
export {
  U as default
};
